module.exports = __webpack_public_path__ + "img/step2.051c30b1.gif";